// Pages/TenantPaymentSettings/TenantPaymentSettingsPage.tsx
import React, { useState } from 'react';
import { TenantPaymentSettingsList } from '../../components/tenantPaymentSettings/TenantPaymentSettingsList';
import { TenantPaymentSettingsForm } from '../../components/tenantPaymentSettings/TenantPaymentSettingsForm';
import { Button } from '../../components/ui/Button';

export function TenantPaymentSettingsPage() {
  const [editId, setEditId] = useState<number | undefined>(undefined);
  const [isCreating, setIsCreating] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleEdit = (id: number) => {
    setEditId(id);
    setIsCreating(false);
  };

  const handleCreateNew = () => {
    setEditId(undefined);
    setIsCreating(true);
  };

  const handleSuccess = () => {
    setEditId(undefined);
    setIsCreating(false);
    setRefreshTrigger(prev => prev + 1);
  };

  const handleCancel = () => {
    setEditId(undefined);
    setIsCreating(false);
  };

  const handleRefresh = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <div className="block px-0">
      <div className="flex justify-between items-center mb-0">
        <h1 className="text-xl font-bold text-gray-800 mt-0 mb-4">Invoice Payment Settings</h1>
      </div>

      {(isCreating || editId) ? (
        <TenantPaymentSettingsForm 
          id={editId}
          onSuccess={handleSuccess}
          onCancel={handleCancel}
        />
      ) : (
        <TenantPaymentSettingsList 
          onEdit={handleEdit}
          onRefresh={handleRefresh}
          refreshTrigger={refreshTrigger}
          createNew={handleCreateNew}
        />
      )}
    </div>
  );
}